// Tip.jsx
import React, { useState, useRef } from "react";
import "./Tip.css";

export default function Tip({ text, children, side = "right" }) {
  const [open, setOpen] = useState(false);
  const hideTimer = useRef(null);

  const show = () => {
    window.clearTimeout(hideTimer.current);
    setOpen(true);
  };

  const hide = () => {
    window.clearTimeout(hideTimer.current);
    setOpen(false);
  };

  const touchPeek = () => {
    show();
    hideTimer.current = window.setTimeout(() => {
      setOpen(false);
    }, 1100);
  };

  return (
    <span
      className={`tcp-tipwrap tcp-tipwrap--${side} ${open ? "is-open" : ""}`}
      onPointerEnter={(e) => e.pointerType !== "touch" && show()}
      onPointerLeave={hide}
      onFocusCapture={show}
      onBlurCapture={hide}
      onPointerDown={(e) => e.pointerType === "touch" && touchPeek()}
    >
      {children}

      <span className="tcp-tip" role="tooltip">
        {text}
      </span>
    </span>
  );
}
